import { render, staticRenderFns } from "./TVDisplaySales.vue?vue&type=template&id=5a1eb745&scoped=true&"
import script from "./TVDisplaySales.vue?vue&type=script&lang=ts&"
export * from "./TVDisplaySales.vue?vue&type=script&lang=ts&"
import style0 from "./TVDisplaySales.vue?vue&type=style&index=0&id=5a1eb745&prod&lang=css&"
import style1 from "./TVDisplaySales.vue?vue&type=style&index=1&id=5a1eb745&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1eb745",
  null
  
)

export default component.exports